var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#5C5C5C",
    viewBox: "0 0 14 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.622 1.298A2.143 2.143 0 0 0 0 2.814a2.161 2.161 0 0 0 .622 1.515l8.249 8.34-8.25 8.34a2.145 2.145 0 0 0-.62 1.515 2.164 2.164 0 0 0 .62 1.515 2.119 2.119 0 0 0 1.5.628 2.1 2.1 0 0 0 1.499-.628l9.758-9.866A2.144 2.144 0 0 0 14 12.659a2.161 2.161 0 0 0-.622-1.515L3.62 1.277C2.812.46 1.45.46.622 1.298Z"
  })));
};
export default SvgChevronRight;